import { Fragment, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { enableLargeTextGA } from "../analytics";
import Icon from "../Components/Common/Icon";
import { useScrollToTop } from "../Hooks/useScrollToTop";
import { getConfigSelector, getTermsDataSelector } from "../Redux/appStateSlice";
import { toggleStateWithGA, transformHtmlWithLinks } from "../utils";

function Terms() {
  useScrollToTop();
  const [largeText, setLargeText] = useState(false);
  const config = useSelector(getConfigSelector);
  const termsData = useSelector(getTermsDataSelector);

  const toggleTextSize = () => toggleStateWithGA(setLargeText, enableLargeTextGA);

  return (
    <>
      <Helmet>
        <title>{`Terms & Conditions - Club £${config.promotion}`}</title>
      </Helmet>

      <Container>
        <Row className="pt-5">
          <Col>
            <h1 className="d-inline">Terms &amp; Conditions</h1>
            <Button
              size="sm"
              variant="light-shade"
              className="py-0 toggle-large-text float-none float-sm-right mt-2"
              onClick={toggleTextSize}
              style={{ minWidth: "162px" }}
            >
              <Icon icon="text" size="175" variant="primary" /> {largeText ? "Decrease" : "Increase"} font size
            </Button>
          </Col>
        </Row>
        <Row className={`py-5 terms${largeText ? " large-text" : ""}`}>
          <Col>
            {
              termsData?.reduce(
                (acc, { title, listItems }, i) => {
                  const currentStart = acc.start;
                  acc.start += listItems.length; // Increment for next section

                  acc.elements.push(
                    <Fragment key={i}>
                      <h2>{title}</h2>
                      <ol start={currentStart}>
                        {listItems.map((htmlString, j) => (
                          <li key={j}>{transformHtmlWithLinks(htmlString)}</li>
                        ))}
                      </ol>
                    </Fragment>,
                  );

                  return acc;
                },
                { start: 1, elements: [] },
              ).elements
            }
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default Terms;
